/* eslint-disable no-param-reassign */
import Framework from '@greenville/framework';
import axios from 'axios';
import env from './common/env';
import utils from './common/utils';
import { USER_LAST_ACCESSED_HEADER } from './common/constants';
import { identifyUser } from './modules/aiadmin/utils/mixPanelUtils';

/**
 * Attaches a given access token to a MS Graph API call. Returns information about the user
 * @param accessToken
 */
export async function callMsGraph(accessToken) {
  const headers = {
    Authorization: `Bearer ${accessToken}`
  };
  const getTenantsConfig = () => {
    Framework.getStoreRegistry().getStore('tenantConfig').fetch();
  };

  const resource = 'https://graph.microsoft.com';
  try {
    let userData = Framework.getStoreRegistry().getStore('user');
    if (userData.email === null || userData.email === '') {
      const response = await axios.get(`${resource}/v1.0/me`, { headers });
      const user = {
        id: response.data.id,
        userName: response.data.givenName,
        firstName: response.data.givenName,
        lastName: response.data.surname,
        initials: response.data.givenName.slice(0, 1) + response.data.surname.slice(0, 1),
        email: response.data.mail
      };
      Framework.getStoreRegistry().getStore('user').set(user);
    }

    userData = Framework.getStoreRegistry().getStore('user');
    let usersId = Framework.getStoreRegistry().getStore('userid');
    const userPermissions = Framework.getStoreRegistry().getStore('userPermissions');
    if (userData.email && usersId.userdetails.userId === null) {
      const userResponse = await axios.get(`${env.AI_ADMIN_API_BASE_URL}/chatutility/users/email/${userData.email}`, {
        headers: {
          ...headers,
          [USER_LAST_ACCESSED_HEADER]: 1
        }
      });
      if (userResponse) {
        const { status } = userResponse;
        if (status === 401) {
          utils.redirectToLogin();
        } else if (status === 200) {
          Framework.getStoreRegistry().getStore('userid').setUserDetails(userResponse.data);
          usersId = Framework.getStoreRegistry().getStore('userid');
        }
      }
    }
    const { userdetails } = usersId;
    if (userPermissions && !userPermissions?.permissionList?.permissions && userdetails.userId !== null) {
      const permResponse = await axios.get(`${env.AI_ADMIN_API_BASE_URL}/users/${userData.email}/permissions`, {
        headers
      });
      if (permResponse) {
        const { status } = permResponse;
        if (status === 401) {
          utils.redirectToLogin();
        } else if (status === 200) {
          if (permResponse.data?.data) {
            Framework.getStoreRegistry().getStore('userPermissions').setPermissions(permResponse.data);
            const userId = userdetails.userId.toString();
            Framework.getStoreRegistry().getStore('user').setAuthenticated(userId, accessToken, '');
            getTenantsConfig();
            identifyUser({ userId });
          }
        }
      }
    }
  } catch (e) {
    console.error(e);
    utils.redirectToLogin();
  }
}

export default callMsGraph;
